import { Avatar } from "@dicebear/core"
import { AVATAR_STYLE, AVATAR_OPTIONS } from "./avatar_options"

const CAPTURE_SIZE = 320

export function captureAvatarPng(seed) {
  const svg = new Avatar(AVATAR_STYLE, { ...AVATAR_OPTIONS, seed, size: CAPTURE_SIZE }).toString()
  return svgToPngBlob(svg)
}

function svgToPngBlob(svg) {
  const svgBlob = new Blob([svg], { type: "image/svg+xml" })
  const url = URL.createObjectURL(svgBlob)

  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = CAPTURE_SIZE
      canvas.height = CAPTURE_SIZE
      canvas.getContext("2d").drawImage(image, 0, 0, CAPTURE_SIZE, CAPTURE_SIZE)
      URL.revokeObjectURL(url)
      canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error("avatar capture failed"))), "image/png")
    }
    image.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error("avatar svg failed to load"))
    }
    image.src = url
  })
}

export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(blob)
  })
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
}
